import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {pushEdapEvent} from '../../../utils/edap';

import {CardCarousel} from '../../common/carousel/Carousel';
import {RatioCard} from '../../common/carousel/Card';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {TABLET_BREAKPOINT} from '../../../utils/constants';

import {fetchImagesByTags} from '../../../actions/property-type-images';
import {fetchPropertyTypePrices} from '../../../actions/property-type-prices';

const ACTION_LOCATION = 'property-types-module';

import {wrapInTest} from '../../common/mvt/utils/mvt';
import {TESTS, getValue} from '../../../utils/abacus';

export function handlerClick(propertyType) {
    const eventOptions = {
        actionlocation: ACTION_LOCATION,
        eventrefinements: propertyType
    };

    const edapOptions = {delayProcessing: true};

    return () => pushEdapEvent('search.link.click', eventOptions, edapOptions);
}

function buildImageUrl(img) {
    return (res) => (img || '').replace('${templateId}', `carousel-${res}`);
}

function createNewImageCard(isMobile, url, item, linkRel, priceLabel) {
    const {footer, img, link, messageKey, serpLink, title} = item;
    const horizontalScrollContainer = {
        event: isMobile ? 'scroll' : 'transitionend',
        element: `.property-types-ratio-cards .CardCarousel__${isMobile ? 'container--scrolling' : 'content'}`
    };

    return (
        <RatioCard
            key={messageKey}
            getImageUrl={buildImageUrl(url)}
            path={serpLink}
            linkRel={linkRel}
            title={title}
            fullName={title}
            footer={footer}
            onClick={handlerClick(link)}
            horizontalScrollContainer={horizontalScrollContainer}
            altText={img.altText}
            priceLabel={priceLabel}
        />
    );
}

export class PropertyTypesComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            mounted: false,
            payload: []
        };
    }

    componentDidMount() {
        const {propertyTypes: {items}} = this.props;
        if (items) {
            this.props.dispatch(fetchImagesByTags(items));
            this.props.dispatch(fetchPropertyTypePrices(this.props.lbsId, items));
        }
    }

    render() {
        const {
            propertyTypes: {title, items, imagesUrls, propertyTypePrices},
            isMobile,
            abacus
        } = this.props;
        if (!items) {
            return null;
        }
        const priceTestValue = getValue(abacus, TESTS.SLP_PROPERTY_TYPE_PRICES);
        const cards = items
            .map((item, index) => {
                const image = (!imagesUrls || imagesUrls.length === 0) ? {url: ''} :
                    imagesUrls.find((img) => img.link === item.link);

                const showPriceLabel = priceTestValue && propertyTypePrices && propertyTypePrices.length > 0;
                const priceLabel = showPriceLabel ? propertyTypePrices.find((price) => price.filterID === item.link) : null;

                const linkRel = index <= 2 ? '' : 'nofollow';
                return createNewImageCard(isMobile, image.url, item, linkRel, priceLabel);
            });

        const cardCarousel = (<div className="container module module--no-padding property-types-ratio-cards">
            <CardCarousel titleMessage={title}>
                {cards}
            </CardCarousel>
        </div>);

        const renderCardCarousel = (propertyTypePrices && propertyTypePrices.length > 0) ? wrapInTest(abacus, TESTS.SLP_PROPERTY_TYPE_PRICES, cardCarousel) : cardCarousel;

        const optimizedSortingTestValue = getValue(abacus, TESTS.OPTIMIZE_PROPERTY_TYPE_SORT);

        return optimizedSortingTestValue === 0 || optimizedSortingTestValue === 1 ?
            wrapInTest(abacus, TESTS.OPTIMIZE_PROPERTY_TYPE_SORT, renderCardCarousel) :
            renderCardCarousel;
    }
}

export function mapStateToProps(state) {
    return {
        propertyTypes: state.modules.propertyTypes,
        isMobile: state.config.isMobile,
        lbsId: state.destination.details.lbsId,
        abacus: state.abacus
    };
}

export const PropertyTypes =
    connect(mapStateToProps)(determineIfMobile(PropertyTypesComponent, TABLET_BREAKPOINT));
